export default __webpack_public_path__ + "static/media/img-0094-china-full-face.1664662c.png";